import { gql } from '@apollo/client';
import { EXPORT_INSTITUTION } from '../../fragments';

export const EXPORT_FUNDER_SUBJECT_REPORT_SCHOOLS = gql`
  query ExportFunderSubjectReportSchools($input: ExportArgs!) {
    allFunderSubjectReportSchools(input: $input) {
      ...exportInstitution
    }
  }
  ${EXPORT_INSTITUTION}
`;
